import { ParametricViewer } from './shape-diver';

export type NameLabel = { name: string; label: string };

export type InputConfig =
  | string // just the shape diver model name
  | NameLabel; // to use different label

export type ExportConfig = InputConfig;

export type SectionConfig = {
  name: string;
  label?: string;
  inputs: InputConfig[];
};

export type AppConfig = {
  ticketId: string;
  leftPanel: SectionConfig[];
  profilePanel: {
    label: string;
    inputs: InputConfig[];
  };
  downloadPanel: {
    label: string;
    fileNameInput: InputConfig;
    exports: ExportConfig[];
  };
  uploadPanel: {
    label: string;
    inputs: InputConfig[];
  };
  rememberedInputs: string[];
};

export function getRememberedInputIds(viewer: ParametricViewer) {
  return viewer.parameters
    .get()
    .data.filter(
      (p) => PW.config.rememberedInputs.indexOf(p.name as string) !== -1
    )
    .map((p) => p.id as string);
}
